import classnames from "classnames";
import React, { useState } from "react";
import logo from "../../assets/img/logo.svg";
import "../../assets/styles/Header.scss";
import ContentWrapper from "../ContentWrapper";

export const Header = () => {
  const [links, setLinks] = useState(false);
  return (
    <header>
      <ContentWrapper>
        <div className="row no-gutters justify-content-between">
          <div className="links">
            <div className="hamburger" onClick={() => setLinks(!links)}>
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
            <div className={classnames("links-wrapper", { open: links })}>
              <a href="../" className="link main">
                strona główna
              </a>
              <a href="../cv.html" className="link">
                generator CV
              </a>
              <a href="../kursy.html" className="link">
                kursy online
              </a>
              <a href="../qa.html" className="link">
                odpowiedzi na pytania
              </a>
              <a href="../praca.html" className="link">
                konto do pracy
              </a>
            </div>
          </div>
          <a href="../">
            <img src={logo} className="logo" alt="logo" />
          </a>
        </div>
      </ContentWrapper>
    </header>
  );
};

export default Header;
